// extracted by mini-css-extract-plugin
export default {"innerWrapper":"bs-z","tooltipWrapper":"cs-z","icon":"ds-z","tooltip":"es-z","content":"fs-z"};